import { render, staticRenderFns } from "./access-control-badge-list.vue?vue&type=template&id=3c5705ca&scoped=true&"
import script from "./access-control-badge-list.vue?vue&type=script&lang=ts&"
export * from "./access-control-badge-list.vue?vue&type=script&lang=ts&"
import style0 from "./access-control-badge-list.vue?vue&type=style&index=0&id=3c5705ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5705ca",
  null
  
)

export default component.exports